export const TEXTS = {
  SKIP_TRACK: 'Пропустить трек',
  CANCEL: 'Отменить',
  SKIP_TRACK_TITLE: 'Пропустить трек',
};
